import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mr-4"
}

import AButtonPrimary from '@/components/atoms/AButtonPrimary.vue'
	import AButtonSplit from '@/components/atoms/AButtonSplit.vue'

	import type { ObjectContext } from '@/global'
	import type { ComputedRef } from 'vue'
	import { computed } from 'vue'
	import { useGeneral, useMainView } from '@/hooks'

	
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

	const { $t, $router, $route, goToMainView, $store, isNew, isCopy, isEdit, isDetail, icons, tabSelected, density } = useGeneral()
	const { menuItems } = useMainView()

	const formStep = computed(() => $store.getters['forms/GET_STEP'])
	const formStepCount = computed(() => $store.getters['forms/GET_STEP_COUNT'])
	const formIsLastStep = computed(() => $store.getters['forms/IS_LAST_STEP'])
	const showSteps = computed(() => (isEdit.value || isCopy.value) && formStepCount.value > 1)

	const showButtonPrimary = computed(() => isEdit.value || isCopy.value)
	// const showButtonSecondary = computed(() => (isEdit.value && !isNew.value) || (isEdit.value && formStepCount.value > 1))
	const showButtonSecondary = computed(() => isNew.value || isEdit.value || isCopy.value)
	const buttonMainText = computed(() => (formStepCount.value > 1 && !formIsLastStep.value ? 'Action_next' : 'Action_save'))
	const buttonSecondaryText = computed(() => (isDetail.value ? 'Action_close' : 'Action_cancel'))

	const routeIcon: ComputedRef = computed(() => icons[$route.name])
	const menuItemsHeader: ComputedRef = computed(() => {
		const menu = $route.name === 'config' ? 'MENU_CONFIG' : 'MENU_RECORDS'
		let items = JSON.parse(JSON.stringify(menuItems.value))
		items = menuItems.value.map((e: ObjectContext) => {
			return {
				text: e.element,
				value: e.tab,
				icon: e.icon
			}
		})
		if (menu === 'MENU_CONFIG') items = items.filter((e: ObjectContext) => e.value !== 'documents')
		const idx = items.findIndex((e: ObjectContext) => e.value === tabSelected.value)
		const selectedItem = items[idx]
		items.splice(idx, 1)
		items.unshift(selectedItem)
		return items
	})

	const breadcrumbs: ComputedRef = computed(() => {
		const routeName: string = $route.name.replace('_edit', '').replace('_copy', '')
		const routeId: string = $route.params.id
		const items = [
			{ text: $t('Route_' + routeName), disabled: false },
			{ text: $t('General_' + tabSelected.value), disabled: false }
		]
		if (routeId) {
			const text = isNew.value ? 'Action_create' : isCopy.value ? 'Action_copy' : 'Action_edit'
			items.push({ text: $t(text), disabled: false })
		}
		return items
	})

	function createItem(tab: string) {
		console.log(`🚀 ~ createItem ~ tab`, tab)
		const routeName = $route.name + '_edit'
		$router.replace({ name: routeName, params: { tab, id: 'create' } })
		// $store.commit('SET_TAB_SELECTED', tab)
	}

	function onCancel() {
		goToMainView()
	}

	function onMainClick() {
		$store.dispatch('onMainClick')
	}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    flat: "",
    prominent: "",
    color: "primary",
    class: "px-12"
  }, {
    append: _withCtx(() => [
      _createElementVNode("div", null, [
        (_unref(showSteps))
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref($t)('General_step_current_of', null, { step: _unref(formStep), count: _unref(formStepCount) })), 1))
          : _createCommentVNode("", true),
        (_unref(showButtonSecondary))
          ? (_openBlock(), _createBlock(AButtonPrimary, {
              key: 1,
              text: _unref(buttonSecondaryText),
              color: "error",
              class: "mr-2",
              "min-width": 185,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (onCancel()))
            }, null, 8, ["text"]))
          : _createCommentVNode("", true),
        (!_unref(isDetail) || _unref(isNew))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (_unref(showButtonPrimary))
                ? (_openBlock(), _createBlock(AButtonPrimary, {
                    key: 0,
                    text: _unref(buttonMainText),
                    "min-width": 185,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (onMainClick()))
                  }, null, 8, ["text"]))
                : (_openBlock(), _createBlock(AButtonSplit, {
                    key: 1,
                    text: "Action_create",
                    "min-width": 185,
                    "default-value": _unref(tabSelected),
                    items: _unref(menuItemsHeader),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (createItem($event)))
                  }, null, 8, ["default-value", "items"]))
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_toolbar_title, null, {
        default: _withCtx(() => [
          (_unref(routeIcon))
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                class: "mr-2",
                icon: _unref(routeIcon)
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_breadcrumbs, {
            density: _unref(density),
            items: _unref(breadcrumbs)
          }, {
            divider: _withCtx(() => [
              _createVNode(_component_v_icon, {
                icon: _unref(icons)['chevronRight']
              }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["density", "items"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})